import React from 'react';
import { useRevealChildren } from '../../hooks/useRevealChildren';
import { focusAreas } from '../../data/focusAreas';
import FocusCard from './FocusCard';
import { Link } from 'react-router-dom';
import ArrowIcon from '../shared/ArrowIcon';
import './FocusAreas.css';

function FocusAreas() {
  const ref = useRevealChildren();

  return (
    <section className="focus-section" id="focus" ref={ref}>
      <div className="container">
        <div className="section-header reveal">
          <div className="section-eyebrow">What We Do</div>
          <h2 className="section-title">Focus Area</h2>
          <p className="section-subtitle">
            Our work spans four critical domains driving sustainable impact
            across communities and landscapes.
          </p>
        </div>
        <div className="focus-grid">
          {focusAreas.map((area) => (
            <FocusCard key={area.title} {...area} />
          ))}
        </div>
        <div className="focus-cta reveal">
          <Link to="/focus-area" className="btn-light">
            Discover More <ArrowIcon />
          </Link>
        </div>
      </div>
    </section>
  );
}

export default FocusAreas;
